import './global-polyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { ErrorBoundary } from './ErrorBoundary';
import { LoginGate } from './auth/LoginGate';
import { loadFromStorage, startAutoSave } from './persistence/local-store';
import { applyColorScheme, installSystemListener, useTheme } from './chrome/theme';
import './index.css';

// Theme: apply persisted color-scheme/class/meta before first paint; wire the
// system-pref listener so 'system' mode tracks OS changes live.
applyColorScheme(useTheme.getState().theme);
installSystemListener();

// Frame-preview tabs (`/frame/<id>`) render a read-only mirror of the editor —
// they load + subscribe via the doc source themselves and must NOT start
// autosave (a preview must never clobber the canvas it's mirroring).
if (!window.location.pathname.startsWith('/frame/')) {
  loadFromStorage();
  startAutoSave();
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <LoginGate>
        <RouterProvider router={router} />
      </LoginGate>
    </ErrorBoundary>
  </React.StrictMode>,
);
